export default __webpack_public_path__ + "static/media/Component 28.6f3aa476.png";